import axios from "axios";
import { useCallback, useEffect, useMemo, useState } from "react";
import useSWR from "swr";

import { useAuthDataContext } from "./auth-provider";

const development: boolean =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

const getHeadersPadrao = (token: string | undefined) => {
  return {
    "Access-Control-Allow-Origin": "*",
    Authorization: "Bearer " + (token ?? ""),
    "Content-Type": "application/json",
  };
};

function createApi(token: string) {
  var base = "api/v1/";

  const api = axios.create({
    baseURL: development
      ? `http://localhost:5000/${base}`
      : `https://softon.azurewebsites.net/${base}`,
    // baseURL: `https://softon.azurewebsites.net/${base}`,
    headers: getHeadersPadrao(token),
  });

  return api;
}

const defaultApi = createApi("");

export const useApi = (base: string = "apcmobile/") => {
  const { user } = useAuthDataContext();

  const get = useCallback(
    async <T>(url: string, timeout?: number) => {
      let token = "";
      if (user) {
        token = await user.getToken();
      }

      const resp = await defaultApi.get<T>(base + url, {
        headers: getHeadersPadrao(token),
        timeout: timeout,
      });

      return { data: resp.data, status: resp.status };
    },
    [user, base],
  );

  const post = useCallback(
    async <T>(url: string, body?: any, timeout?: number) => {
      let token = "";
      if (user) {
        token = await user.getToken();
      }

      const resp = await defaultApi.post<T>(base + url, body, {
        headers: getHeadersPadrao(token),
        timeout: timeout,
      });
      return { data: resp.data, status: resp.status };
    },
    [user, base],
  );

  return useMemo(() => ({ api: { get, post }, user }), [get, post, user]);
};

interface FetcherResponse<T = any> {
  status: number;
  data: T;
}

export function useFetcher<Data = any>(
  url: string,
  refreshIntervel: number = 0,
) {
  const { api, user } = useApi();

  const [tnt, setTnt] = useState<string | undefined>(undefined);

  const { data, error, mutate, isValidating } = useSWR<FetcherResponse<Data>>(
    url,
    async (url) => {
      var resp = await api.get<Data>(url);

      return { data: resp.data, status: resp.status };
    },
    { revalidateOnFocus: false, refreshInterval: refreshIntervel },
  );

  // a ideia é forçar o SWR a dar um refresh caso o usuario
  // troque de tenant, para isso armazenamos o tenant anterior
  useEffect(() => {
    if (tnt && tnt !== user?.tenantId) {
      mutate(undefined, true);
    }
    if (user?.tenantId) {
      setTnt(user?.tenantId);
    }
  }, [user, tnt, mutate]);

  return { response: data, error, mutate, isValidating };
}
